"use strict";
// Consumer product locales
// https://wiki.sc-corp.net/display/Engineering/Consumer+Product+Localization
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCALE = exports.RTL_LOCALES = exports.ALL_LOCALES = exports.LANGUAGE_TO_DEFAULT_LOCALE = exports.ALTERNATE_LOCALE_CODES = exports.LanguageCode = exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["ar"] = "ar";
    Locale["arAR"] = "ar-AR";
    Locale["bnBD"] = "bn-BD";
    Locale["bnIN"] = "bn-IN";
    Locale["daDK"] = "da-DK";
    Locale["deDE"] = "de-DE";
    Locale["elGR"] = "el-GR";
    Locale["enGB"] = "en-GB";
    Locale["enUS"] = "en-US";
    Locale["es"] = "es";
    Locale["esAR"] = "es-AR";
    Locale["esES"] = "es-ES";
    Locale["esMX"] = "es-MX";
    Locale["fiFI"] = "fi-FI";
    Locale["filPH"] = "fil-PH";
    Locale["frFR"] = "fr-FR";
    Locale["guIN"] = "gu-IN";
    Locale["hiIN"] = "hi-IN";
    Locale["idID"] = "id-ID";
    Locale["itIT"] = "it-IT";
    Locale["jaJP"] = "ja-JP";
    Locale["knIN"] = "kn-IN";
    Locale["koKR"] = "ko-KR";
    Locale["mlIN"] = "ml-IN";
    Locale["mrIN"] = "mr-IN";
    Locale["msMY"] = "ms-MY";
    Locale["nbNO"] = "nb-NO";
    Locale["nlNL"] = "nl-NL";
    Locale["pa"] = "pa";
    Locale["plPL"] = "pl-PL";
    Locale["ptBR"] = "pt-BR";
    Locale["ptPT"] = "pt-PT";
    Locale["roRO"] = "ro-RO";
    Locale["ruRU"] = "ru-RU";
    Locale["svSE"] = "sv-SE";
    Locale["taIN"] = "ta-IN";
    Locale["teIN"] = "te-IN";
    Locale["thTH"] = "th-TH";
    Locale["trTR"] = "tr-TR";
    Locale["urPK"] = "ur-PK";
    Locale["viVN"] = "vi-VN";
    Locale["zhHans"] = "zh-Hans";
    Locale["zhHant"] = "zh-Hant";
    /** Psuedo-localized en-US */
    Locale["enPLOC"] = "en-PLOC";
})(Locale = exports.Locale || (exports.Locale = {}));
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["ar"] = "ar";
    LanguageCode["bn"] = "bn";
    LanguageCode["da"] = "da";
    LanguageCode["de"] = "de";
    LanguageCode["el"] = "el";
    LanguageCode["en"] = "en";
    LanguageCode["es"] = "es";
    LanguageCode["fi"] = "fi";
    LanguageCode["fil"] = "fil";
    LanguageCode["fr"] = "fr";
    LanguageCode["gu"] = "gu";
    LanguageCode["hi"] = "hi";
    LanguageCode["id"] = "id";
    LanguageCode["it"] = "it";
    LanguageCode["ja"] = "ja";
    LanguageCode["kn"] = "kn";
    LanguageCode["ko"] = "ko";
    LanguageCode["ml"] = "ml";
    LanguageCode["mr"] = "mr";
    LanguageCode["ms"] = "ms";
    LanguageCode["nb"] = "nb";
    LanguageCode["nl"] = "nl";
    LanguageCode["pl"] = "pl";
    LanguageCode["pt"] = "pt";
    LanguageCode["ro"] = "ro";
    LanguageCode["ru"] = "ru";
    LanguageCode["sv"] = "sv";
    LanguageCode["ta"] = "ta";
    LanguageCode["te"] = "te";
    LanguageCode["th"] = "th";
    LanguageCode["tr"] = "tr";
    LanguageCode["ur"] = "ur";
    LanguageCode["vi"] = "vi";
    LanguageCode["zh"] = "zh";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
const ALTERNATE_LOCALES = {
    // Traditional Chinese code in Chrome
    zhTW: "zh-TW",
    // Simplified Chinese code in Chrome
    zhCN: "zh-CN",
};
// Alternate popular Locale codes for the standardized versions
exports.ALTERNATE_LOCALE_CODES = {
    [Locale.zhHant]: [ALTERNATE_LOCALES.zhTW],
    [Locale.zhHans]: [ALTERNATE_LOCALES.zhCN],
};
/**
 * Default locales given language code
 */
exports.LANGUAGE_TO_DEFAULT_LOCALE = {
    [LanguageCode.ar]: Locale.arAR,
    [LanguageCode.bn]: Locale.bnBD,
    [LanguageCode.da]: Locale.daDK,
    [LanguageCode.de]: Locale.deDE,
    [LanguageCode.el]: Locale.elGR,
    [LanguageCode.en]: Locale.enUS,
    [LanguageCode.es]: Locale.esES,
    [LanguageCode.fi]: Locale.fiFI,
    [LanguageCode.fil]: Locale.filPH,
    [LanguageCode.fr]: Locale.frFR,
    [LanguageCode.gu]: Locale.guIN,
    [LanguageCode.hi]: Locale.hiIN,
    [LanguageCode.id]: Locale.idID,
    [LanguageCode.it]: Locale.itIT,
    [LanguageCode.ja]: Locale.jaJP,
    [LanguageCode.kn]: Locale.knIN,
    [LanguageCode.ko]: Locale.koKR,
    [LanguageCode.ml]: Locale.mlIN,
    [LanguageCode.mr]: Locale.mrIN,
    [LanguageCode.ms]: Locale.msMY,
    [LanguageCode.nb]: Locale.nbNO,
    [LanguageCode.nl]: Locale.nlNL,
    [LanguageCode.pl]: Locale.plPL,
    [LanguageCode.pt]: Locale.ptBR,
    [LanguageCode.ro]: Locale.roRO,
    [LanguageCode.ru]: Locale.ruRU,
    [LanguageCode.sv]: Locale.svSE,
    [LanguageCode.ta]: Locale.taIN,
    [LanguageCode.te]: Locale.teIN,
    [LanguageCode.th]: Locale.thTH,
    [LanguageCode.tr]: Locale.trTR,
    [LanguageCode.ur]: Locale.urPK,
    [LanguageCode.vi]: Locale.viVN,
    [LanguageCode.zh]: Locale.zhHans,
};
exports.ALL_LOCALES = [
    Locale.ar,
    Locale.arAR,
    Locale.bnBD,
    Locale.bnIN,
    Locale.daDK,
    Locale.deDE,
    Locale.elGR,
    Locale.enGB,
    Locale.enUS,
    Locale.es,
    Locale.esAR,
    Locale.esES,
    Locale.esMX,
    Locale.fiFI,
    Locale.filPH,
    Locale.frFR,
    Locale.guIN,
    Locale.hiIN,
    Locale.idID,
    Locale.itIT,
    Locale.jaJP,
    Locale.knIN,
    Locale.koKR,
    Locale.mlIN,
    Locale.mrIN,
    Locale.msMY,
    Locale.nbNO,
    Locale.nlNL,
    Locale.pa,
    Locale.plPL,
    Locale.ptBR,
    Locale.ptPT,
    Locale.roRO,
    Locale.ruRU,
    Locale.svSE,
    Locale.taIN,
    Locale.teIN,
    Locale.thTH,
    Locale.trTR,
    Locale.urPK,
    Locale.viVN,
    Locale.zhHans,
    Locale.zhHant,
];
exports.RTL_LOCALES = [Locale.ar, Locale.arAR, Locale.urPK];
exports.DEFAULT_LOCALE = Locale.enUS;
//# sourceMappingURL=constants.js.map